import Page from '../../classes/Page';

const businessPage = new Page({
    onCreate() {
        console.log('businessPage create')
    },

    onInit() {
        this.components.modal.setCallbacks('js-success-save-modal', {
            onOpen: () => {},
            onClose: () =>  {
                window.location.href = '/'
            }
        });

    },

    onDestroy() {
        console.log('businessPage destroy')
    },

    name: 'business',
    rootElementId: 'js-page-business'
});

export default businessPage;
